import React from 'react';
import Button from "react-bootstrap/Button";
import {useHistory} from "react-router-dom";
import {reloadOrRedirect} from '../../../utils/location-utils';
import {SchemaProps} from "../../../types/Schema";
import IconButton from "../../buttons/icon-button/IconButton";

type UploadSchemaActionProps = {
  schema?: SchemaProps;
  schemaId?: string;
  standardButton?: boolean;
  forbidden?: boolean
  disabled?: boolean
};

/**
 * Generic action for starting schema upload workflow.
 *
 * @param {UploadSchemaActionProps} props
 * @returns {any}
 * @constructor
 */
export default function UploadSchemaAction(props: UploadSchemaActionProps) {
  const history = useHistory();
  const schemaId = props.schemaId || props.schema?.id || '';
  const title = schemaId ? 'Upload New Version' : 'Upload Schema';
  const url = !schemaId ? '/schema/upload' : `/schema/upload?id=${schemaId}`;
  const pageUrl = '/schema/upload';
  const disabled = props.forbidden || props.disabled;
  const tooltip = props.forbidden ? 'Upload schema is forbidden' : title;
  return props.standardButton ?
    <Button onClick={() => reloadOrRedirect(history, pageUrl, url)}
            disabled={disabled}
            title={tooltip}
            className="btn btn-primary UploadSchemaAction">
      {title}
    </Button> :
    <IconButton icon="upload" onClick={() => reloadOrRedirect(history, pageUrl, url)}
                disabled={disabled}
                title={tooltip}
                className="UploadSchemaAction"/>
}
